import { useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
// import LoadingOverlay from "src/components/common/form/LoadingOverlay";

import { WMS1060_R01Dto } from "./Dto_WMS1060_R01";
import SearchSection_WMS1060_R01 from "./SearchSection_WMS1060_R01";
import { Table_WMS1060_R01 } from "./Table_WMS1060_R01";
import { Content_WMS1060_R01 } from "./Content_WMS1060_R01";
import { useWMS1060_R01Store } from "./Store_WMS1060_R01";

import useUiuxStore from "src/store/useUiuxStore";
import {Message} from "src/components/common/form/Message";

export const Container_WMS1060_R01 = () => {
    
    // ========================================
    // Store
    // ========================================
    const { allCount } = useWMS1060_R01Store();
    const { tabList, setMessage } = useUiuxStore();
    
    // ========================================
    // Refs
    // ========================================
    const gridRef = useRef<AgGridReact<WMS1060_R01Dto>>(null);
    
    // ========================================
    // Content Hook (비즈니스 로직)
    // ========================================
    const {
        fetchData,
        handleExcelClick,
        initContainerData,
    } = Content_WMS1060_R01({
        gridRef,
        tabList,
        setMessage,
    });
    
    // ========================================
    // UI 렌더링
    // ========================================
    return (
        <div className="content-container">
            
            {/* Action Bar */}
            <Actionbar
                onFetchClick={fetchData}
                onCreateClick={undefined}   // 조회 전용
                onDeleteClick={undefined}   // 조회 전용
                onSaveClick={undefined}     // 조회 전용
                onPrintClick={undefined}    // 미사용
                onExcelClick={handleExcelClick}
                onInitClick={initContainerData}
            />
            
            {/* Search Section */}
            <SearchSection_WMS1060_R01 
                onEnterKeyDown={fetchData}
            />
            
            <div className="flex-1 overflow-hidden p-3 ">
                <Table_WMS1060_R01 gridRef={gridRef} />
            </div>
            
            <Message />
        </div>
    );
};

export default Container_WMS1060_R01;
